import * as React from "react";
import { Button, Table } from "react-bootstrap";
import PrintIcon from "@mui/icons-material/Print";
import { useState } from "react";
import { getStudentsAllData, fetchStudentPhoto, fetchStudentSign, getDocumentByStudentID, 
  fetchSubjectbyStudentID } from "../api/studentDetails";
import {
  Page,
  Text,
  View,
  Document,
  pdf,
  Image
} from "@react-pdf/renderer";

function PrintApplication({ applications }) {
  const token =
    typeof window !== "undefined" ? localStorage.getItem("token") : null;

  const studentId =
    typeof window !== "undefined" ? localStorage.getItem("id") : null;

  const handlePrintClick = async (application) => {
    const studentId = application.userInfo.id;
    const courseId = application.course.id;

    try {
      const response = await getStudentsAllData(studentId, courseId, token);
      const studentData = response.data;

      console.log("getStudentsAllData:", studentData);

      const photoResponse = await fetchStudentPhoto(token, studentId);
      const signResponse = await fetchStudentSign(token, studentId);

      console.log("Photo Response:", photoResponse);
      console.log("Sign Response:", signResponse);

      const photoType = photoResponse.headers["content-type"] || "image/jpeg";
      const signType = signResponse.headers["content-type"] || "image/jpeg";

      const photoBlob = new Blob([photoResponse.data], { type: photoType });
      const signBlob = new Blob([signResponse.data], { type: signType });

      const photoUrl = await blobToDataUrl(photoBlob);
      const signUrl = await blobToDataUrl(signBlob);

      const documentResponse = await getDocumentByStudentID(token, studentId, courseId);
      const documents = documentResponse.data || [];

      console.log("Fetched Documents:", documents);

      const subjectResponse = await fetchSubjectbyStudentID(token, studentId, courseId);
      console.log("Subject Response:", subjectResponse);


      if (subjectResponse && subjectResponse.data) {
        const { majorDisciplines = [], otherSubjectCategories = [] } = subjectResponse.data;

        const majorDisciplineIds = majorDisciplines.map(md => md.majorDiscipline.id);
        console.log("Major Discipline IDs:", majorDisciplineIds);

        const majorSubjects = otherSubjectCategories
          .filter(sub => majorDisciplineIds.includes(sub.discipline.id))
          .map(sub => ({
            subjectCode: sub.subjectDefinition?.subjectCode || "N/A",
            subjectName: sub.subjectDefinition?.subjectName || "N/A"
          }));

        const minorSubjects = otherSubjectCategories
          .filter(sub => !majorDisciplineIds.includes(sub.discipline.id))
          .map(sub => ({
            subjectCode: sub.subjectDefinition?.subjectCode || "N/A",
            subjectName: sub.subjectDefinition?.subjectName || "N/A"
          }));

        const doc = <PDFReport
          studentData={studentData}
          photoUrl={photoUrl}
          signUrl={signUrl}
          documents={documents}
          majorSubjects={majorSubjects}
          minorSubjects={minorSubjects} />;

        const blob = await pdf(doc).toBlob();

        const url = URL.createObjectURL(blob);
        const a = document.createElement("a");
        a.href = url;
        a.download = "student_application.pdf";
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
        URL.revokeObjectURL(url);
      }
    } catch (error) {
      console.error("Error fetching student details:", error);
    }
  };

  const blobToDataUrl = (blob) => {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onloadend = () => resolve(reader.result);
      reader.onerror = reject;
      reader.readAsDataURL(blob);
    });
  };

  const PDFReport = ({ studentData, photoUrl, signUrl, documents, majorSubjects, minorSubjects }) => {
    const renderHeader = () => (
      <View style={{ flexDirection: "column", borderColor: "black" }}>
        {Array.isArray(studentData) ? (
          studentData.map((student, index) => (
            <View key={index}>
              <View style={{ borderBottom: "1px solid #000", width: '100%', textAlign: 'center', marginBottom: 5, flexDirection: 'row', alignItems: 'center', justifyContent: 'space-between' }}>
                <View style={{ flex: 1, alignItems: 'center', }}>
                  <Text style={{ fontSize: 6, marginBottom: "5px" }}>
                    Maharashtra Education Society's
                  </Text>
                  <Text style={{ fontSize: 10, marginBottom: "5px" }}>
                    MES GARWARE COLLEGE OF COMMERCE (AUTONOMOUS)
                  </Text>
                  <Text style={{ fontSize: 8, marginBottom: "5px" }}>
                    KARVE ROAD, DECCAN GYMKHANA, PUNE - 411004
                  </Text>
                  <Text style={{ fontSize: 8, marginBottom: "5px" }}>
                    Affilated to Savitribai Phule Pune University
                  </Text>
                  <Text style={{ fontSize: 8, marginBottom: "5px" }}>
                    UBI-ID-NO:PU/PN/C/018/(1967)
                  </Text>
                  <Text style={{ fontSize: 8, marginBottom: "5px" }}>
                    NAAC Re-Accredited - 'A' Grade (CGPA - 3.45)
                  </Text>                     <Text style={{ fontSize: 8, marginBottom: "5px" }}>
                    Best College Award By Savitribai Phule Pune University
                  </Text>
                </View>
                <View style={{ alignItems: "center", marginRight: 10 }}>

                  <View style={{ padding: 15 }}>
                    {photoUrl ? (
                      <Image source={{ uri: photoUrl }} style={{ width: 100, height: 100, border: "1px solid black" }} />
                    ) : (
                      <Text>No Photo Available</Text>
                    )}
                  </View>
                  <View style={{ padding: 10 }}>
                    {signUrl ? (
                      <Image source={{ uri: signUrl }} style={{ width: 100, height: 50, border: "1px solid black" }} />
                    ) : (
                      <Text>No Signature Available</Text>
                    )}
                  </View>
                  <View>
                  </View>
                </View>
              </View>

              <View style={{ marginTop: 10, flexDirection: 'column', borderBottomWidth: 1, borderLeftWidth: 1, borderRightWidth: 1, borderTopWidth: 1, borderColor: 'black', }}>
                <Text style={{
                  fontSize: 9, textAlign: 'left', borderBottomWidth: 1, padding: 5, backgroundColor: "#8697c4"
                }}>
                  1. Personal Information Section
                </Text>

                <View style={{ flexDirection: 'row' }}>
                  <Text style={{ flex: 1, fontSize: 8, padding: 5, borderBottomWidth: 1, borderRightWidth: 1 }}>
                  </Text>
                  <Text style={{ flex: 1, fontSize: 8, padding: 5, borderBottomWidth: 1, borderRightWidth: 1, fontWeight: "700" }}>
                    Last Name:
                  </Text>
                  <Text style={{ flex: 1, fontSize: 8, padding: 5, borderBottomWidth: 1, borderRightWidth: 1 }}>
                    First Name:
                  </Text>
                  <Text style={{ flex: 1, fontSize: 8, padding: 5, borderBottomWidth: 1, }}>
                    Middle Name:
                  </Text>
                </View>

                <View style={{ flexDirection: 'row' }}>
                  <Text style={{ flex: 1, fontSize: 8, padding: 5, borderBottomWidth: 1, borderRightWidth: 1 }}>
                    Name of Student:
                  </Text>
                  <Text style={{ flex: 1, fontSize: 8, padding: 5, borderBottomWidth: 1, borderRightWidth: 1 }}>
                    {student.last_name || "NA"}
                  </Text>
                  <Text style={{ flex: 1, fontSize: 8, padding: 5, borderBottomWidth: 1, borderRightWidth: 1 }}>
                    {student.first_name || "NA"}
                  </Text>
                  <Text style={{ flex: 1, fontSize: 8, padding: 5, borderBottomWidth: 1, }}>
                    {student.middle_name || "NA"}
                  </Text>
                </View>

                <View style={{ flexDirection: 'row', }}>
                  <Text style={{ flex: 1, fontSize: 8, padding: 5, borderBottomWidth: 1, borderRightWidth: 1 }}>
                    Father's Name: {student.father_name || "NA"}
                  </Text>
                  <Text style={{ flex: 1, fontSize: 8, padding: 5, borderBottomWidth: 1, borderRightWidth: 1 }}>
                    Mother's Name: {student.mother_name || "NA"}
                  </Text>
                  <Text style={{ flex: 1, fontSize: 8, padding: 5, borderBottomWidth: 1, }}>
                    In-House Student: {student.in_house ? "Yes" : "No"}

                  </Text>
                </View>

                <View style={{ flexDirection: 'row', }}>
                  <Text style={{ flex: 1, fontSize: 8, padding: 5, borderBottomWidth: 1, borderRightWidth: 1 }}>
                    Date of Birth: {student.date_of_birth || "NA"}
                  </Text>
                  <Text style={{ flex: 1, fontSize: 8, padding: 5, borderBottomWidth: 1, borderRightWidth: 1 }}>
                    Gender: {student.gender || "NA"}
                  </Text>
                  <Text style={{ flex: 1, fontSize: 8, padding: 5, borderBottomWidth: 1, }}>
                    Aadhar Card No: {student.aadhaar_card_no || "NA"}
                  </Text>
                </View>

                <View style={{ flexDirection: 'row', }}>
                  <Text style={{ flex: 1, fontSize: 8, padding: 5, borderBottomWidth: 1, borderRightWidth: 1 }}>
                    Caste Category: {student.caste_category || "NA"}
                  </Text>
                  <Text style={{ flex: 1, fontSize: 8, padding: 5, borderBottomWidth: 1, borderRightWidth: 1 }}>
                    Phy. Handicapped: {student.differently_abled ? "Yes" : "No"}
                  </Text>
                  <Text style={{ flex: 1, fontSize: 8, padding: 5, borderBottomWidth: 1, }}>
                    Religion: {student.religion || "NA"}
                  </Text>
                </View>

                <View style={{ flexDirection: 'row', }}>
                  <Text style={{ flex: 1, fontSize: 8, padding: 5, borderRightWidth: 1, borderBottomWidth: 1, }}>
                    Nationality: {student.nationality || "NA"}
                  </Text>
                  <Text style={{ flex: 1, fontSize: 8, padding: 5, borderRightWidth: 1, borderBottomWidth: 1, }}>
                    Birth Place: {student.birth_place || "NA"}
                  </Text>
                  <Text style={{ flex: 1, fontSize: 8, padding: 5, borderBottomWidth: 1, }}>
                    Is Orphan: {student.orphan ? "Yes" : "No"}

                  </Text>
                </View>

                <View style={{ flexDirection: 'row', }}>
                  <Text style={{ flex: 1, fontSize: 8, padding: 5, borderRightWidth: 1, }}>
                    Annual Income: {student.annual_income || "NA"}
                  </Text>
                  <Text style={{ flex: 1, fontSize: 8, padding: 5, borderRightWidth: 1, }}>
                    Blood Group: {student.blood_group || "NA"}
                  </Text>
                  <Text style={{ flex: 1, fontSize: 8, padding: 5, }}>
                    Marital Status: {student.marital_status || "NA"}

                  </Text>
                </View>

              </View>

              <View style={{ marginTop: 5, flexDirection: 'column', borderBottomWidth: 1, borderLeftWidth: 1, borderRightWidth: 1, borderTopWidth: 1, borderColor: 'black' }}>
                <Text style={{ fontSize: 9, textAlign: 'left', borderBottomWidth: 1, padding: 5, backgroundColor: "#8697c4" }}>
                  2. Address Details
                </Text>
                <View style={{ flexDirection: 'row' }}>
                  <Text style={{ flex: 1, fontSize: 8, padding: 5, borderBottomWidth: 1, borderRightWidth: 1 }}>
                    Address of Correspondence : {student.current_address || "NA"}
                  </Text>
                  <Text style={{ flex: 1, fontSize: 8, padding: 5, borderBottomWidth: 1 }}>
                    Pin Code : {student.current_pin_code || "NA"}
                  </Text>
                </View>

                <View style={{ flexDirection: 'row' }}>
                  <Text style={{ flex: 1, fontSize: 8, padding: 5, borderBottomWidth: 1, borderRightWidth: 1 }}>
                    State : {student.current_state || "NA"}
                  </Text>
                  <Text style={{ flex: 1, fontSize: 8, padding: 5, borderBottomWidth: 1, borderRightWidth: 1 }}>
                    Taluka : {student.current_taluka || "NA"}
                  </Text>
                  <Text style={{ flex: 1, fontSize: 8, padding: 5, borderBottomWidth: 1 }}>
                    City : {student.current_city || "NA"}
                  </Text>
                </View>

                <View style={{ flexDirection: 'row' }}>
                  <Text style={{ flex: 1, fontSize: 8, padding: 5, borderBottomWidth: 1, borderRightWidth: 1 }}>
                    Permanent Address : {student.permanent_address || "NA"}
                  </Text>
                  <Text style={{ flex: 1, fontSize: 8, padding: 5, borderBottomWidth: 1 }}>
                    Pin Code : {student.permanent_pin_code || "NA"}
                  </Text>
                </View>
                <View style={{ flexDirection: 'row' }}>
                  <Text style={{ flex: 1, fontSize: 8, padding: 5, borderRightWidth: 1 }}>
                    State : {student.permanent_state || "NA"}
                  </Text>
                  <Text style={{ flex: 1, fontSize: 8, padding: 5, borderRightWidth: 1 }}>
                    Taluka : {student.permanent_taluka || "NA"}
                  </Text>
                  <Text style={{ flex: 1, fontSize: 8, padding: 5 }}>
                    City : {student.permanent_city || "NA"}
                  </Text>
                </View>
              </View>

              <View style={{ marginTop: 5, flexDirection: 'column', borderBottomWidth: 1, borderLeftWidth: 1, borderRightWidth: 1, borderTopWidth: 1, borderColor: 'black', }}>
                <Text style={{ fontSize: 9, textAlign: 'left', borderBottomWidth: 1, padding: 5, backgroundColor: "#8697c4" }}>
                  3. Contact Details
                </Text>
                <View style={{ flexDirection: 'row' }}>
                  <Text style={{ flex: 1, fontSize: 8, padding: 5, borderBottomWidth: 1, borderRightWidth: 1 }}>
                    Student Mobile No: {student.student_mobile || "NA"}
                  </Text>
                  <Text style={{ flex: 1, fontSize: 8, padding: 5, borderBottomWidth: 1, }}>
                    Parent phone: {student.parent_mobile || "NA"}
                  </Text>
                </View>

                <View style={{ flexDirection: 'row' }}>
                  <Text style={{ flex: 1, fontSize: 8, padding: 5, }}>
                    Student Email Id: {student.student_email || "NA"}
                  </Text>
                </View>
              </View>

              <View style={{ marginTop: 30, flexDirection: 'column', borderBottomWidth: 1, borderLeftWidth: 1, borderRightWidth: 1, borderTopWidth: 1, borderColor: 'black' }}>
                <Text style={{ fontSize: 9, textAlign: 'left', borderBottomWidth: 1, padding: 5, backgroundColor: "#8697c4" }}>
                  4. Qualifying Exam Details Section / lsAppear -
                </Text>

                {/* Display Qualifying Exam Name and Stream */}
                <View style={{ flexDirection: 'row', justifyContent: 'space-between', marginTop: 5 }}>
                  <Text style={{ flex: 1, fontSize: 9, textAlign: 'left', padding: 5 }}>
                    QUALIFYING EXAM NAME: {student.last_exam_name}
                  </Text>
                  <Text style={{ flex: 1, fontSize: 9, textAlign: 'right', padding: 5 }}>
                    QUALIFYING EXAM STREAM: {student.stream}
                  </Text>
                </View>

                {/* Table header */}
                <View style={{ flexDirection: 'row', borderTopWidth: 1, backgroundColor: "#EDE8F5" }}>
                  <Text style={{ flex: 1, fontSize: 8, padding: 5, borderBottomWidth: 1, borderRightWidth: 1 }}>College/School Attended</Text>
                  <Text style={{ flex: 1, fontSize: 8, padding: 5, borderBottomWidth: 1, borderRightWidth: 1 }}>Board/University</Text>

                  <Text style={{ flex: 1, fontSize: 8, padding: 5, borderBottomWidth: 1, borderRightWidth: 1 }}>Passing Year</Text>
                  <Text style={{ flex: 1, fontSize: 8, padding: 5, borderBottomWidth: 1, borderRightWidth: 1 }}>Marks Obt</Text>
                  <Text style={{ flex: 1, fontSize: 8, padding: 5, borderBottomWidth: 1, borderRightWidth: 1 }}>Total Marks</Text>
                  <Text style={{ flex: 1, fontSize: 8, padding: 5, borderBottomWidth: 1, borderRightWidth: 1 }}>Percentage</Text>
                  <Text style={{ flex: 1, fontSize: 8, padding: 5, borderBottomWidth: 1, borderRightWidth: 1 }}>Stream</Text>
                  <Text style={{ flex: 0.5, fontSize: 8, padding: 5, borderBottomWidth: 1 }}>Education Gap</Text>
                </View>

                {/* Render qualification details */}
                <View style={{ flexDirection: 'row', borderTopWidth: 1 }}>
                  <Text style={{ flex: 1, fontSize: 8, padding: 5, borderBottomWidth: 1, borderRightWidth: 1 }}>
                    {student.college}
                  </Text>
                  <Text style={{ flex: 1, fontSize: 8, padding: 5, borderBottomWidth: 1, borderRightWidth: 1 }}>
                    {student.university_and_board || 'N/A'}
                  </Text>

                  <Text style={{ flex: 1, fontSize: 8, padding: 5, borderBottomWidth: 1, borderRightWidth: 1 }}>
                    {student.passing_year || 'N/A'}
                  </Text>
                  <Text style={{ flex: 1, fontSize: 8, padding: 5, borderBottomWidth: 1, borderRightWidth: 1 }}>
                    {student.obtained_marks || 'N/A'}
                  </Text>
                  <Text style={{ flex: 1, fontSize: 8, padding: 5, borderBottomWidth: 1, borderRightWidth: 1 }}>
                    {student.total_marks || 'N/A'}
                  </Text>
                  <Text style={{ flex: 1, fontSize: 8, padding: 5, borderBottomWidth: 1, borderRightWidth: 1 }}>
                    {student.percentage || 'N/A'} %
                  </Text>
                  <Text style={{ flex: 1, fontSize: 8, padding: 5, borderBottomWidth: 1, borderRightWidth: 1 }}>
                    {student.stream || 'N/A'}
                  </Text>
                  <Text style={{ flex: 0.5, fontSize: 8, padding: 5, borderBottomWidth: 1 }}>
                    {student.gap || "NA"}
                  </Text>
                </View>
              </View>
            </View>
          ))
        ) : (
          <Text style={{ fontSize: 8, padding: 5 }}>No Student Data Found</Text>
        )}

        <View style={{ marginTop: 10, flexDirection: 'column', borderBottomWidth: 1, borderLeftWidth: 1, borderRightWidth: 1, borderTopWidth: 1, borderColor: 'black' }}>
          <Text style={{ fontSize: 9, textAlign: 'left', borderBottomWidth: 1, padding: 5, backgroundColor: "#8697c4" }}>
            5. Document Details -
          </Text>

          {/* Display Qualifying Exam Name and Stream */}
          <View style={{ flexDirection: 'row', justifyContent: 'space-between', marginTop: 5 }}>
            <Text style={{ flex: 1, fontSize: 9, textAlign: 'left', padding: 5 }}>
              DOCUMENTS:
            </Text>

          </View>

          {/* Table header */}
          <View style={{

            flexDirection: 'column',
            borderWidth: 0.5,
            borderColor: 'black'
          }}>

            {/* Table Header */}
            <View style={{ flexDirection: 'row', borderTopWidth: 1, backgroundColor: "#EDE8F5", borderBottomWidth: 1 }}>
              <Text style={{ flex: 1, fontSize: 8, padding: 5, borderRightWidth: 1, fontWeight: "700" }}>
                Sr. No.
              </Text>
              <Text style={{ flex: 3, fontSize: 8, padding: 5, fontWeight: "700", borderRightWidth: 1 }}>
                Document Name
              </Text>
              <Text style={{ flex: 3, fontSize: 8, padding: 5, fontWeight: "700" }}>
                Status
              </Text>
            </View>

            {/* Table Rows - Display Document Names */}
            {documents.length > 0 ? (
              documents.map((doc, index) => (
                <View key={index} style={{ flexDirection: 'row', borderBottomWidth: 1 }}>
                  <Text style={{ flex: 1, fontSize: 8, padding: 5, borderRightWidth: 1 }}>
                    {index + 1}
                  </Text>
                  <Text style={{ flex: 3, fontSize: 8, padding: 5, borderRightWidth: 1 }}>
                    {doc.certificate.certificateName || "NA"}
                  </Text>
                  <Text style={{ flex: 3, fontSize: 8, padding: 5, color: "#1565c0" }}>
                    Attached
                  </Text>
                </View>
              ))
            ) : (
              <Text style={{ fontSize: 8, padding: 5, textAlign: 'center' }}>
                No Documents Available
              </Text>
            )}
          </View>

        </View>

        <View style={{ marginTop: 10, marginBottom:30, flexDirection: 'column', borderBottomWidth: 1, borderLeftWidth: 1, borderRightWidth: 1, borderTopWidth: 1, borderColor: 'black' }}>
          <Text style={{ fontSize: 9, textAlign: 'left', borderBottomWidth: 1, padding: 5, backgroundColor: "#8697c4" }}>
            6. Subject Details -
          </Text>

          <Text style={{ fontSize: 10, fontWeight: 'bold', marginTop: 5, padding: 5 }}>MAJOR SUBJECTS:</Text>
          <View style={{
            flexDirection: 'column',
            width: 800,
            padding: 5
          }}>
            <View style={{ flexDirection: 'row', borderTopWidth: 1, backgroundColor: "#EDE8F5", borderBottomWidth: 1 }}>
              <Text style={{ flex: 1, fontSize: 8, padding: 5, borderRightWidth: 1, fontWeight: "700", borderLeftWidth: 1 }}>Subject Code</Text>
              <Text style={{ flex: 4, fontSize: 8, padding: 5, fontWeight: "700", borderRightWidth: 1 }}>Subject Name</Text>
            </View>
            {majorSubjects?.map((majorSubject, index) => (
              <View style={{ flexDirection: 'row', borderBottomWidth: 1 }} key={index}>
                <Text style={{ flex: 1, fontSize: 8, padding: 5, borderRightWidth: 1, borderLeftWidth: 1 }}>{majorSubject.subjectCode}</Text>
                <Text style={{ flex: 4, fontSize: 8, padding: 5, borderRightWidth: 1 }}>{majorSubject.subjectName}</Text>
              </View>
            ))}
          </View>

          <Text style={{ fontSize: 10, fontWeight: 'bold', marginTop: 5, padding: 5 }}>MINOR SUBJECTS:</Text>
          <View style={{
            flexDirection: 'column',
            width: 800,
            padding: 5
          }}>
            <View style={{ flexDirection: 'row', borderTopWidth: 1, backgroundColor: "#EDE8F5", borderBottomWidth: 1 }}>
              <Text style={{ flex: 1, fontSize: 8, padding: 5, borderRightWidth: 1, fontWeight: "700", borderLeftWidth: 1 }}>Subject Code</Text>
              <Text style={{ flex: 4, fontSize: 8, padding: 5, fontWeight: "700", borderRightWidth: 1 }}>Subject Name</Text>
            </View>
            {minorSubjects?.map((minorSubject, index) => (
              <View style={{ flexDirection: 'row', borderBottomWidth: 1 }} key={index}>
                <Text style={{ flex: 1, fontSize: 8, padding: 5, borderRightWidth: 1, borderLeftWidth: 1 }}>{minorSubject.subjectCode}</Text>
                <Text style={{ flex: 4, fontSize: 8, padding: 5, borderRightWidth: 1 }}>{minorSubject.subjectName}</Text>
              </View>
            ))}
          </View>

        </View>

        <View style={{ marginTop: 60, flexDirection: 'column', borderBottomWidth: 1, borderLeftWidth: 1, borderRightWidth: 1, borderTopWidth: 1, borderColor: 'black', }}>
          <Text style={{ fontSize: 9, textAlign: 'left', borderBottomWidth: 1, padding: 5, backgroundColor: "#8697c4" }} >
            7. Declaration by Student
          </Text>
          <Text style={{ fontSize: 9, textAlign: 'left', marginBottom: 10, padding: 10 }}>
            I hereby declare that, I have read the rules related to admission and the information filled in by me in this form is accurate and true to the best of my knowledge. I will be responsible for any discrepancy, arising out of the form signed by me and I undertake that, in absence of any document the final admission will not be granted and/or admission will stand cancel.
          </Text>
          <View style={{ flexDirection: 'row', justifyContent: 'space-between', borderBottomWidth: 1 }}>
            <Text style={{ fontSize: 9, textAlign: 'left', marginBottom: 10, padding: 10 }}>
              Place:
            </Text>


            <View style={{ alignItems: 'center', padding: 1 }}>
              {signUrl ? (
                <Image source={{ uri: signUrl }} style={{ width: 100, height: 50, border: "1px solid black" }} />
              ) : (
                <Text>No Signature Available</Text>
              )}
              <Text style={{ fontSize: 9, textAlign: 'center', marginTop: 2 }}>
                Signature of Student
              </Text>
            </View>
          </View>
        </View>

        <View style={{ marginTop: 5, flexDirection: 'column', borderBottomWidth: 1, borderLeftWidth: 1, borderRightWidth: 1, borderTopWidth: 1, borderColor: 'black', }}>
          <Text style={{ fontSize: 9, textAlign: 'left', borderBottomWidth: 1, padding: 5, backgroundColor: "#8697c4" }}>
            8. Declaration by Guardian / Parent
          </Text>
          <Text
            style={{ fontSize: 9, textAlign: 'left', marginBottom: 10, padding: 10 }} >
            I have permitted my son/ daughter/ ward to join your college. The information supplied by him/ her is correct to the best of my knowledge. I have acquainted myself with the rules and fees, dues to my son/daughter/ward and see that he/she observes.
          </Text>

          <Text style={{ fontSize: 9, textAlign: 'left', marginBottom: 10, padding: 10 }}>
            Place:
          </Text>
          <View style={{ flexDirection: 'row', justifyContent: 'space-between', borderBottomWidth: 1 }}>
            <Text style={{ fontSize: 9, textAlign: 'left', marginBottom: 10, padding: 10 }}>
              Date:
            </Text>
            <Text style={{ fontSize: 9, textAlign: 'right', marginBottom: 10, padding: 10 }}>
              Signature of the Guardian/Parent
            </Text>
          </View>
        </View>

        <View style={{ marginTop: '5', flexDirection: 'column', borderBottomWidth: 1, borderLeftWidth: 1, borderRightWidth: 1, borderTopWidth: 1, borderColor: 'black', }}>
          <Text style={{ fontSize: 9, textAlign: 'left', borderBottomWidth: 1, padding: 5, backgroundColor: "#8697c4" }}>
            9. For College/ Institute Use Only
          </Text>
          <View style={{ flexDirection: 'row' }}>

            <Text style={{ flex: 1, fontSize: 8, padding: 5, borderBottomWidth: 1, borderRightWidth: 1 }}>
              Designation
            </Text>
            <Text style={{ flex: 1, fontSize: 8, padding: 5, borderBottomWidth: 1, borderRightWidth: 1 }}>
              Remarks/ Particular/ Recommendation
            </Text>
            <Text style={{ flex: 1, fontSize: 8, padding: 5, borderBottomWidth: 1, }}>
              Signature and Date
            </Text>
          </View>
          <View style={{ flexDirection: 'row' }}>
            <Text style={{ flex: 1, fontSize: 8, padding: 5, borderBottomWidth: 1, borderRightWidth: 1 }}>
              Admission Clerk
            </Text>
            <Text style={{ flex: 1, fontSize: 8, padding: 5, borderBottomWidth: 1, borderRightWidth: 1 }}>
            </Text>
            <Text style={{ flex: 1, fontSize: 8, padding: 5, borderBottomWidth: 1, }}>
            </Text>
          </View>
          <View style={{ flexDirection: 'row', }}>
            <Text style={{ flex: 1, fontSize: 8, padding: 5, borderBottomWidth: 1, borderRightWidth: 1 }}>
              Admission Committee
            </Text>
            <Text style={{ flex: 1, fontSize: 8, padding: 5, borderBottomWidth: 1, borderRightWidth: 1 }}>
            </Text>
            <Text style={{ flex: 1, fontSize: 8, padding: 5, borderBottomWidth: 1, }}>
            </Text>
          </View>
          <View style={{ flexDirection: 'row', }}>
            <Text style={{ flex: 1, fontSize: 8, padding: 5, borderBottomWidth: 1, borderRightWidth: 1 }}>
              Accountant/ cashier
            </Text>
            <Text style={{ flex: 1, fontSize: 8, padding: 5, borderBottomWidth: 1, borderRightWidth: 1 }}>
            </Text>
            <Text style={{ flex: 1, fontSize: 8, padding: 5, borderBottomWidth: 1, }}>
            </Text>
          </View>

          <View style={{ flexDirection: 'row', }}>
            <Text style={{ flex: 1, fontSize: 8, padding: 5, borderBottomWidth: 1, borderRightWidth: 1 }}>
              Registrar/Office superintendent
            </Text>
            <Text style={{ flex: 1, fontSize: 8, padding: 5, borderBottomWidth: 1, borderRightWidth: 1 }}>
            </Text>
            <Text style={{ flex: 1, fontSize: 8, padding: 5, borderBottomWidth: 1, }}>
            </Text>
          </View>
          <View style={{ flexDirection: 'row', }}>
            <Text style={{ flex: 1, fontSize: 8, padding: 5, borderBottomWidth: 1, borderRightWidth: 1 }}>
              Transaction Details
            </Text>
            <Text style={{ flex: 1, fontSize: 8, padding: 5, borderBottomWidth: 1, borderRightWidth: 1 }}>
              <View style={{ flex: 1, padding: 5, borderBottomWidth: 1, borderRightWidth: 1, justifyContent: 'space-between' }}>
                <Text style={{ fontSize: 8, marginBottom: 5, alignItems: 'left' }}>
                  Payment Mode: { }
                </Text>
                <Text style={{ fontSize: 8, marginBottom: 5, alignItems: 'center' }}>
                  Cash Received:{ }
                </Text>
                <Text style={{ fontSize: 8, alignItems: 'right' }}>
                  Transaction ID: { }
                </Text>
              </View>
            </Text>
            <Text style={{ flex: 1, fontSize: 8, padding: 5, borderBottomWidth: 1, }}>
            </Text>
          </View>
        </View>

        <View style={{ marginTop: 60, borderRightWidth: 0.8, borderTopWidth: 1, borderLeftWidth: 0.8, Padding: 5 }}>
          <Text style={{ fontSize: 9, textAlign: 'left', borderBottomWidth: 1, padding: 5, backgroundColor: "#8697c4" }}>
            REMARK OF THE ADMISSION COMMITTEE
          </Text>
          <View >
            <View style={{ flexDirection: 'row', justifyContent: 'space-between', alignItems: 'center', marginTop: 10 }}>
              <Text style={{ fontSize: 8, textAlign: 'left', marginBottom: 15, padding: 5, marginTop: 10 }}>
                May be admitted to Class   ____________________________________________________________________Section_________________________
              </Text>
            </View>

            <Text style={{ fontSize: 8, textAlign: 'left', marginBottom: 15, padding: 5 }}>
              May be Rejected ___________________________________________________________________________________
            </Text>

            <Text style={{ fontSize: 8, textAlign: 'left', marginBottom: 15, padding: 5 }}>
              Last date of payment of fees ___________________________________________________________________________________
            </Text>

            <Text style={{ fontSize: 8, textAlign: 'left', marginBottom: 10, padding: 5 }}>
              Admission may be cancelled if the fees are not paid by this date.
            </Text>

            <Text style={{ fontSize: 9, textAlign: 'left', marginBottom: 10, padding: 10 }}>
              Principal
            </Text>

            <View style={{ flexDirection: 'row', justifyContent: 'space-between', borderBottomWidth: 1, padding: 10 }}>
              <Text style={{ fontSize: 9, textAlign: 'left', marginBottom: 10, Padding: 10 }} >
                Date:
              </Text>
              <Text style={{ fontSize: 9, textAlign: 'right', marginBottom: 10, Padding: 10 }}
              >           Signature of Admission Committee
              </Text>
            </View>
          </View>
        </View>
      </View>
    )

    return (
      <Document>
        <Page size="A4" orientation="landscape" style={{ padding: 20 }}>
          <View>{renderHeader()}</View>
        </Page>
      </Document>
    );

  }
  return (
    <>
      <Table responsive="sm">
        <thead
          style={{
            backgroundColor: "#6e48aa",
            color: "#fff",
            fontSize: "15px",
            fontWeight: "600",
          }}
        >
          <tr>
            <th style={{ width: "30%" }}>Course</th>
            <th style={{ width: "15%" }}>Application No</th>
            <th style={{ width: "15%" }}>Application Status</th>
            <th>Paymode</th>
            <th>Action</th>
            <th style={{ width: "15%" }}>Payment Receipt</th>
          </tr>
        </thead>
        <tbody>
          {applications.map((application) => (
            <tr key={application.id}>
              <td>{application.course.courseName}</td>
              <td>{application.applicationNumber}</td>
              <td
                style={{
                  color: application.verify ? "green" : "red",
                  fontWeight: "500",
                }}
              >
                {application.verify ? "Confirm" : "Not-Confirm"}
              </td>
              <td>{application.paymentMode || "NA"}</td>
              <td style={{ textAlign: "center" }}>
                <Button className="btn" onClick={() => handlePrintClick(application)}>
                  <PrintIcon style={{ fontSize: "18px" }} /> Print
                </Button>
              </td>
              <td>{application.paymentReceipt || "NA"}</td>
            </tr>
          ))}
        </tbody>
      </Table>
    </>
  );


}

export default PrintApplication;